<header class="header">
  <a class="logo-container" href="https://www.vidasecurity.cl/"
    ><img class="logo" src="assets/logos/Logo_VidaSecurity.svg"
  /></a>
  <!-- <script type="module" src="../node_modules/@vs-design-system/ds-button/dist/bundle.js"></script>
      <script type="module" src="../node_modules/@vs-design-system/ds-container/dist/bundle.js"></script>
      <script type="module" src="../node_modules/@vs-design-system/ds-icon/dist/bundle.js"></script>
      <script type="module" src="../node_modules/@vs-design-system/ds-input/dist/bundle.js"></script>
      <script type="module" src="../node_modules/@vs-design-system/ds-messaging/dist/bundle.js"></script>
      <script type="module" src="../node_modules/@vs-design-system/ds-paragraph/dist/bundle.js"></script>
      <script type="module" src="../node_modules/@vs-design-system/ds-spinner/dist/bundle.js"></script>
      <script type="module" src="../node_modules/@vs-design-system/ds-title/dist/bundle.js"></script>-->
</header>

<div class="background"></div>

<body class="body">
  <!-- Google Tag Manager (noscript)
  <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-TRG96TX" height="0" width="0"
      style="display:none;visibility:hidden"></iframe></noscript>
  <!-- End Google Tag Manager (noscript) -->
  <div class="box">
    <div class="tab">

      <!--
      <div
        class="tablinks"
        [class.active]="isCustomerActive"
        (click)="selectTab(loginType.Customer)">
        ACCESO CLIENTES
      </div>
    -->
      <div
        class="tablinks"
        [class.active]="isBrokerActive"
        (click)="selectTab(loginType.Broker)"
      >
        ACCESO INTERMEDIARIOS Y CORREDORES
      </div>
    </div>
    <div class="content-tab">
      <div class="content-tap-option" [class.is-visible]="isCustomerActive">
        <form class="form-group" [formGroup]="form" (ngSubmit)="onSubmit()">
          <div
            class="form-control"
            [class.invalid]="
              (rutControl.invalid && rutControl.touched) || invalidRequest
            "
          >
            <input
              formControlName="rut"
              formatRut
              type="text"
              placeholder="Rut"
            />
            <div *ngIf="rutControl.invalid && rutControl.touched">
              <span
                class="error-label"
                *ngIf="
                  rutControl?.errors?.required || rutControl?.errors?.invalidRut
                "
                >RUT no es válido.</span
              >
            </div>
            <span class="error-label" *ngIf="invalidRequest"
              >Nombre de usuario o clave incorrectos.</span
            >
          </div>
          <div
            class="form-control"
            [class.invalid]="
              (passwordControl.invalid && passwordControl.touched) ||
              invalidRequest
            "
          >
            <input
              formControlName="password"
              type="password"
              placeholder="Contraseña"
            />
            <div *ngIf="passwordControl.invalid && passwordControl.touched">
              <span
                class="error-label"
                *ngIf="passwordControl?.errors?.required"
                >Ingrese su contraseña.</span
              >
            </div>
            <span class="error-label" *ngIf="invalidRequest"
              >Si olvidaste tu clave o no la tienes, ingresa a recuperar o
              solicitar clave.</span
            >
          </div>
          <div class="aditional-information" *ngIf="invalidRequest">
            En caso de alguna inquietud, comunícate con
            <span class="highlight">Servicio al Cliente</span> a través del
            <span class="highlight">800 222 100</span> o escribe a
            <a class="email" href="mailto:contactovida@security.cl"
              >contactovida@security.cl</a
            >
          </div>
          <button
            [disabled]="form.invalid || invalidRequest || isLoading"
            type="submit"
            class="btn"
          >
            Ingresar
          </button>
        </form>
      </div>
      <div class="content-tap-option" [class.is-visible]="isBrokerActive">
        <iframe
          class="iframe-login"
          src="https://clientes.vidasecurity.cl/CMSVidaSecurity/Widgets/LoginIntermediarioSSO.html"
          width="350"
          height="305"
          frameborder="0"
          gesture="media"
          allow="encrypted-media"
          allowfullscreen=""
        ></iframe>
      </div>
      <!---->
    </div>

    <footer class="recovery-password">
      <a (click)="goToRecoveryPassword()" class="link">
        Recuperar o solicitar clave
      </a>
    </footer>
  </div>

  <!-- <div class="footerIndex">
    Sitio optimizado para navegadores Google Chrome, Firefox y Edge.
     <script type="text/javascript" src="assets/"></script>
    <script type="text/javascript" src="../login/resources/ds-astro/ds-design/ds-container/dist/bundle.js"></script>
    <script type="text/javascript" src="../login/resources/ds-astro/ds-design/ds-icon/dist/bundle.js"></script>
    <script type="text/javascript" src="../login/resources/ds-astro/ds-design/ds-input/dist/bundle.js"></script>
    <script type="text/javascript" src="../login/resources/ds-astro/ds-design/ds-messaging/dist/bundle.js"></script>
    <script type="text/javascript" src="../login/resources/ds-astro/ds-design/ds-paragraph/dist/bundle.js"></script>
    <script type="text/javascript" src="../login/resources/ds-astro/ds-design/ds-spinner/dist/bundle.js"></script>
    <script type="text/javascript" src="../login/resources/ds-astro/ds-design/ds-title/dist/bundle.js"></script>
    </div> -->
</body>
